import {
  FETCH_INVENTORY_REPORTS_SUCCESS,
  FETCH_INVENTORY_REPORTS_FAIL,
  DELETE_INVENTORY_REPORT_SUCCESS,
  CREATE_INVENTORY_REPORT_SUCCESS,
  CREATE_INVENTORY_REPORT_FAILURE,
  UPDATE_INVENTORY_REPORT,
  FETCH_ARCHIVED_INVENTORY_REPORTS_SUCCESS,
  FETCH_SHOPIFY_LOCATIONS_SUCCESS,
  FETCH_SHOPIFY_LOCATIONS_FAILURE
} from '../constants';

const initialState = {
  reports: [],
  archivedReports: [],
  pagy: {},
  reportItems: [],
  shopifyLocations: [],
  error: null
};

const inventoryReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVENTORY_REPORTS_SUCCESS:
      return { ...state, reports: action.payload.inventory_reports, reportItems: action.payload.inventory_report_items || [], pagy: action.payload.pagy, error: null };
    case FETCH_ARCHIVED_INVENTORY_REPORTS_SUCCESS:
      return { ...state, archivedReports: action.payload.inventory_reports, reportItems: action.payload.inventory_report_items || [], archivedPagy: action.payload.pagy, error: null };
    case FETCH_INVENTORY_REPORTS_FAIL:
      return { ...state, error: action.payload };
    case DELETE_INVENTORY_REPORT_SUCCESS:
      return { ...state, reports: state.reports.filter(report => report.id !== action.payload) };
    case CREATE_INVENTORY_REPORT_SUCCESS:
      return { ...state, loading: false, success: true, error: null, reports: [...state.reports, action.payload], };
    case CREATE_INVENTORY_REPORT_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload, };
    case UPDATE_INVENTORY_REPORT:
      return { ...state, reports: state.reports.map(report => report.id === action.payload.id ? action.payload : report ), };
    case FETCH_SHOPIFY_LOCATIONS_SUCCESS:
      return { ...state, shopifyLocations: action.payload, error: null };
    case FETCH_SHOPIFY_LOCATIONS_FAILURE:
      return { ...state, shopifyLocations: [], error: action.payload };
    default:
      return state;
  }
};

export default inventoryReportsReducer;
